import React, { Component } from "react";

class Sidebar extends Component {
  render() {
    return (
      <aside className="card-side" aria-label="Profile">
        <button
          id="langToggle"
          className="lang-toggle"
          type="button"
          aria-label="Switch language"
          onClick={this.props.onChangeLanguage}
        >
          <i className="bi bi-translate"></i>

          <span>{this.props.language === "en" ? "فارسی" : "EN"}</span>
        </button>

        <div className="side-inner">
          <div className="avatar-wrap">
            <span className="avatar-ring" aria-hidden="true"></span>
            <img
              src="/image/contact1.PNG"
              alt="Portrait of sftmh"
              className="avatar"
            />
          </div>
          <h1
            className="side-name"
            data-en="Seyede Fatemeh Zare"
            data-fa="سیده فاطمه زارع"
          >
            Seyede Fatemeh Zare
          </h1>
          <p
            className="side-role"
            data-en="Digital Experience Creator"
            data-fa="سازنده تجربه‌های دیجیتال"
          >
            Digital Experience Creator
          </p>
          <ul className="side-socials" aria-label="Social links">
            <li>
              <a
                href="https://www.linkedin.com/in/sftmhzare2004"
                target="_blank"
                aria-label="LinkedIn"
              >
                <i className="bi bi-linkedin"></i>
              </a>
            </li>
            <li>
              <a
                href="https://t.me/Sftmh_zare"
                target="_blank"
                aria-label="telegram"
              >
                <i className="bi bi-telegram"></i>
              </a>
            </li>
            <li>
              <a
                href="https://instagram.com/ftmh_zre_"
                target="_blank"
                aria-label="instagram"
              >
                <i className="bi bi-instagram"></i>
              </a>
            </li>
          </ul>
          <a
            href="/image/MyResume.pdf"
            target="_blank"
            className="btn-cv"
            data-en="Download CV"
            data-fa="دانلود رزومه"
          >
            Download CV
          </a>
        </div>
        <p
          className="side-copy"
          data-en="© 2026 All rights reserved."
          data-fa="© ۲۰۲۶ تمامی حقوق محفوظ است."
        >
          © 2026 All rights reserved.
        </p>
      </aside>
    );
  }
}

export default Sidebar;
